import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, ErrorHandler, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger, MatDialog, MatTab, MatTabGroup } from '@angular/material';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { SearchFormType } from '../models/search-form-type.model';
import { SearchQuery } from '../models/search-query.model';
import { AirportFilterListComponent } from '../airport-filter-list/airport-filter-list.component';
import { AirportService } from '../../airport/airport.service';
import { GoogleService } from '../../google/google.service';
import { mergeStates, State } from '../../shared/state-view/state.model';
import { environment } from '../../../environments/environment';
import { AutocompleteOverlayComponent } from '../../shared/autocomplete-overlay/autocomplete-overlay.component';
import { browser } from '../../../browser';
import { AutocompleteOptionType, AutocompleteTriggerComponent, AutocompleteType } from '../../shared/autocomplete-trigger/autocomplete-trigger.component';
import { Source } from '../../shared/models/source.model';
import { WhatsnewComponent } from '../../whatsnew/whatsnew.component';
import { WhatsNewService } from '../../shared/services/whats-new.service';
import { EventFilterListComponent } from '../event-filter-list/event-filter-list.component';
import { AviationEventFiltersService } from '../../shared/services/aviation-event-filters.service';
import { LatLon } from '../../util/geodesy/latlon';
import { AuthService } from '../../auth/auth/auth.service';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
import { FuelFilterListComponent } from '../fuel-filter-list/fuel-filter-list.component';
import { FilterKeys } from '../filters/filters';
import { ShowDialogComponent } from '../../shared/show-dialog/show-dialog.component';
var LandingPageComponent = /** @class */ (function () {
    function LandingPageComponent(_router, _meta, _title, _airportService, _google, _errorHandler, _cdref, _matDialog, _whatsNewService, _aviationEventFiltersService, _route, _auth, _analyticsService) {
        this._router = _router;
        this._meta = _meta;
        this._title = _title;
        this._airportService = _airportService;
        this._google = _google;
        this._errorHandler = _errorHandler;
        this._cdref = _cdref;
        this._matDialog = _matDialog;
        this._whatsNewService = _whatsNewService;
        this._aviationEventFiltersService = _aviationEventFiltersService;
        this._route = _route;
        this._auth = _auth;
        this._analyticsService = _analyticsService;
        this.query = new SearchQuery();
        this.form = new FormGroup({
            wrapper: new FormGroup({
                type: new FormControl(),
                query: new FormControl(),
                usOrInternational: new FormControl()
            })
        });
        this.State = State;
        this.SearchFormType = SearchFormType;
        this.numAirportFiltersSelected = 0;
        this.airportSearchState = State.Empty;
        this.locationState = State.Empty;
        this.videoOverlayActive = false;
        this._title.setTitle(environment.appName);
        this._meta.updateTag({
            name: 'description',
            content: 'AOPA Airports is an online database of thousands of public- and private-use airports. '
                + 'Airport listings include airport diagrams, fuel prices, and more.'
        });
        // This allows the jump to anchor tag to favorites from the airport details page.
        // Ugly.  Hopefully some day they will fix this: https://github.com/angular/angular/issues/6595
        _router.events.subscribe(function (s) {
            if (s instanceof NavigationEnd) {
                var tree = _router.parseUrl(_router.url);
                if (tree.fragment) {
                    var element = document.querySelector('#' + tree.fragment);
                    if (element) {
                        element.scrollIntoView(true);
                    }
                }
            }
        });
    }
    Object.defineProperty(LandingPageComponent.prototype, "queryCtrl", {
        get: function () {
            return this.form.get('wrapper').get('query');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "queryLabel", {
        get: function () {
            if (this.query.type === SearchFormType.Activities) {
                return 'Location';
            }
            else if (this.query.type === SearchFormType.AviationEvents) {
                if (this.isInternational) {
                    return 'Location';
                }
                else {
                    return 'Location (optional)';
                }
            }
            else {
                return 'Airport ID, Name, City, or State';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "searchPlaceholder", {
        get: function () {
            if (this.query.type === SearchFormType.Activities) {
                return 'Search by City Name';
            }
            else if (this.query.type === SearchFormType.AviationEvents) {
                if (this.isInternational) {
                    return 'City or Country Name';
                }
                else {
                    return 'Airport ID, Airport Name, State Name';
                }
            }
            else {
                return 'Search';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "queryType", {
        get: function () {
            return (this.query.type === SearchFormType.Activities)
                ? AutocompleteType.Google
                : AutocompleteType.Combined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "valid", {
        get: function () {
            return this.query.validate().valid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "validationReason", {
        get: function () {
            var result = this.query.validate();
            if (!result.valid) {
                return result.message || 'The query you entered is not valid.';
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "searchState", {
        get: function () {
            return mergeStates(this.airportSearchState, this.locationState);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "searchErrorMsg", {
        get: function () {
            if (this.airportSearchState === State.Error) {
                return 'An error occurred searching for airports or locations. Please try again later.';
            }
            if (this.locationState === State.Error) {
                return 'An error occurred resolving the location latitude and longitude. Please try again later.';
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "isInternational", {
        get: function () {
            return this.form.get('wrapper').get('usOrInternational').value === 'International';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "currentSearchTab", {
        get: function () {
            return this.query.type;
        },
        enumerable: true,
        configurable: true
    });
    LandingPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.aviationEventFilterSubscription = this._aviationEventFiltersService.aviationEventFilter.subscribe(function (ae) {
            _this.aviationEventFilter = ae;
        });
    };
    LandingPageComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var showWhatsNew, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setTimeout(function () {
                            // Workaround to prevent the invisible autocomplete menu overlay element from interfering with pointer
                            // interactions.
                            _this.onQueryBlur();
                            // Store the initially selected tab.
                            _this.selectedTab = _this._getSelectedTab();
                            // Get the number of initially selected filters
                            _this.numAirportFiltersSelected = _this.airportFilters.getNumSelected();
                            setTimeout(function () {
                                if (_this._route.snapshot.queryParamMap.has('t')) {
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'activities') {
                                        _this.query.type = SearchFormType.Activities;
                                    }
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'events') {
                                        _this.query.type = SearchFormType.AviationEvents;
                                    }
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'fuel') {
                                        _this.query.type = SearchFormType.FuelPrice;
                                    }
                                }
                            }, 300);
                        }, 100);
                        return [4 /*yield*/, this._whatsNewService.shouldShowWhatsNew()];
                    case 1:
                        showWhatsNew = _a.sent();
                        if (showWhatsNew) {
                            dialogRef = this._matDialog.open(WhatsnewComponent);
                            dialogRef.afterClosed().subscribe(function (result) {
                                _this._whatsNewService.displayedWhatsNew();
                            });
                        }
                        /* this.aviationEventFilterSubscription = this._aviationEventFiltersService.aviationEventFilter.subscribe(ae => {
                          this.aviationEventFilter = ae;
                        }); */
                        this._analyticsService.pageView('airport_landingpage', 'Airport/Event Landing Page');
                        return [2 /*return*/];
                }
            });
        });
    };
    LandingPageComponent.prototype.ngOnDestroy = function () {
        this.aviationEventFilterSubscription.unsubscribe();
    };
    LandingPageComponent.prototype.changeQueryParams = function () {
        var queryType = SearchFormType.Airports;
        if (this.query.type === SearchFormType.AviationEvents) {
            queryType = SearchFormType.AviationEvents;
            if (this.fuelFilters && this.fuelFilters.fuel100LLFilter) {
                this.fuelFilters.filterComponents.filter(function (c) { return c.filter.enabled; }).forEach(function (filt) {
                    if (filt.filter.key !== FilterKeys.PublicUse) {
                        filt.filter.enabled = false;
                    }
                });
            }
        }
        else if (this.query.type === SearchFormType.Activities) {
            queryType = SearchFormType.Activities;
            if (this.fuelFilters && this.fuelFilters.fuel100LLFilter) {
                this.fuelFilters.filterComponents.filter(function (c) { return c.filter.enabled; }).forEach(function (filt) {
                    if (filt.filter.key !== FilterKeys.PublicUse) {
                        filt.filter.enabled = false;
                    }
                });
            }
        }
        else if (this.query.type === SearchFormType.FuelPrice) {
            queryType = SearchFormType.FuelPrice;
            if (this.airportFilters && this.airportFilters.fuel100LLFilter) {
                this.airportFilters.filterComponents.filter(function (c) { return c.filter.enabled; }).forEach(function (filt) {
                    if (filt.filter.key !== FilterKeys.PublicUse) {
                        filt.filter.enabled = false;
                    }
                });
                // this.airportFilters.fuel100LLFilter.enabled = true;
            }
        }
        else {
            queryType = SearchFormType.Airports;
            if (this.fuelFilters && this.fuelFilters.fuel100LLFilter) {
                this.fuelFilters.filterComponents.filter(function (c) { return c.filter.enabled; }).forEach(function (filt) {
                    if (filt.filter.key !== FilterKeys.PublicUse) {
                        filt.filter.enabled = false;
                    }
                });
                /* this.fuelFilters.fuel100LLFilter.enabled = false;
                this.fuelFilters.fuelJetAFilter.enabled = false;
                this.fuelFilters.fuelMOGASFilter.enabled = false;
                this.fuelFilters.fuelUL94Filter.enabled = false; */
            }
        }
        var queryParams = { 't': queryType };
        this._router.navigate([], {
            relativeTo: this._route,
            queryParams: queryParams,
            queryParamsHandling: 'merge',
        });
    };
    LandingPageComponent.prototype.onSelectTab = function (event) {
        this.selectedTab = event.tab;
    };
    LandingPageComponent.prototype._getSelectedTab = function () {
        var _this = this;
        if (!this.tabGroup._tabs) {
            return null;
        }
        return this.tabGroup._tabs
            .toArray()
            .find(function (tab, i) { return i === _this.tabGroup.selectedIndex; });
    };
    LandingPageComponent.prototype.onSubmit = function () {
        if (this.query.type === SearchFormType.AviationEvents) {
            this.query.aviationEventsFilter = this.aviationEventFilter;
            this.query.radius = 500;
        }
        this.acTrigger.submit(this.query);
    };
    LandingPageComponent.prototype.onClickAdvancedSearch = function () {
        if (this.query.type === SearchFormType.AviationEvents) {
            this.query.aviationEventsFilter = this.aviationEventFilter;
            this.acTrigger.submit(this.query);
            // this._router.navigate(['/search'], { queryParams: {'t': 'events', 'public': 1} });
        }
        else {
            this._router.navigate(['/search'], { queryParams: { 'public': 1 } });
        }
    };
    LandingPageComponent.prototype.onItemSelected = function (e) {
        switch (e.type) {
            case AutocompleteOptionType.Airport:
                if (this.query.type === SearchFormType.AviationEvents) {
                    this.query.term = e.airport.identifier;
                    this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
                    this.query.radius = 50;
                    this.query.aviationEventsFilter = this.aviationEventFilter;
                    var params_1 = this.query.encode();
                    this._router.navigate(['/search'], { queryParams: params_1 });
                }
                else if (this.query.type === SearchFormType.FuelPrice) {
                    this.query.term = '';
                    this.query.locationDescription = e.airport.identifier || '';
                    this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
                    this.query.radius = 50;
                    var params_2 = this.query.encode();
                    this._router.navigate(['/search'], { queryParams: params_2 });
                }
                else {
                    if (e.airport.sourceId === Source.CaribbeanGuide || e.airport.sourceId === Source.BahamasGuide) {
                        this._router.navigate(['/airports', e.airport.identifier, 'island']);
                    }
                    else {
                        this._router.navigate(['/airports', e.airport.identifier]);
                    }
                }
                return;
            case AutocompleteOptionType.Location:
                this.queryFieldEl.nativeElement.value = e.location.description;
                this._resolveLocation(e.location.place_id, e.location.description);
                break;
            case AutocompleteOptionType.State:
                this.queryFieldEl.nativeElement.value = e.state.name;
                this.query.term = '';
                this.query.locationDescription = e.state.name;
                this.query.state = e.state.stateCode;
                break;
            default:
                this.query.type = SearchFormType.Airports;
                this.query.term = e.query;
                var params = this.query.encode();
                this._router.navigate(['/search'], { queryParams: params });
        }
    };
    LandingPageComponent.prototype.onAirportFiltersChanged = function () {
        this.numAirportFiltersSelected = this.airportFilters.getNumSelected();
    };
    LandingPageComponent.prototype.onFuelFiltersChanged = function () {
        this.numAirportFiltersSelected = this.fuelFilters.getNumSelected();
    };
    LandingPageComponent.prototype.onQueryKeyPress = function () {
        var _this = this;
        setTimeout(function () {
            _this.query.term = _this.queryCtrl.value;
            if (_this.queryCtrl && _this.queryCtrl.value && _this.queryCtrl.value.length < 1) {
                _this.query.term = '';
            }
        }, 0);
    };
    LandingPageComponent.prototype.onQueryFocus = function (e) {
        if (browser && (browser.os === 'iOS' || browser.os === 'Android OS')) {
            // Angular Material's autocomplete component is not really usable on mobile:
            // https://github.com/angular/material2/issues/6341
            // Instead, pop up a full-screen overlay with a search box and a filtered list of suggestions
            e.preventDefault();
            this.acOverlay.show();
            this._cdref.detectChanges();
            this.acOverlay.focus();
        }
    };
    LandingPageComponent.prototype.onQueryBlur = function () {
        var _this = this;
        // Workaround to prevent the invisible autocomplete menu overlay element from interfering with pointer interactions.
        setTimeout(function () { return _this.acInputTrigger.closePanel(); }, 300);
    };
    LandingPageComponent.prototype.onQueryTypeChanged = function (event) {
        this.changeQueryParams();
        this.tabGroup.selectedIndex = 1;
    };
    LandingPageComponent.prototype.enableForm = function () {
        this.setEnabledState(true);
    };
    LandingPageComponent.prototype.disableForm = function () {
        this.setEnabledState(false);
    };
    LandingPageComponent.prototype.setEnabledState = function (enabled) {
        this.wrapper.nativeElement.disabled = !enabled;
    };
    LandingPageComponent.prototype._resolveLocation = function (placeId, description) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var location_1, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.locationState = State.Loading;
                        this.disableForm();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this._google.geocodePlace(placeId)];
                    case 2:
                        location_1 = _a.sent();
                        this.query.term = '';
                        this.query.location = location_1;
                        this.query.locationDescription = description || '';
                        this.query.radius = this.query.radius || 50;
                        this.locationState = State.Content;
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        this.locationState = State.Error;
                        return [3 /*break*/, 5];
                    case 4:
                        this.enableForm();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    LandingPageComponent.prototype.openVideoOverlay = function () {
        this.videoOverlayActive = true;
    };
    LandingPageComponent.prototype.closeVideoOverlay = function () {
        this.videoOverlayActive = false;
    };
    LandingPageComponent.prototype.addEventFormClick = function () {
        if (!this._auth.authenticated || !this._auth.endUser) {
            this._auth.redirectToLogin();
            return;
        }
        this._router.navigate(['/addevent']);
    };
    LandingPageComponent.prototype.onClickFavorite = function (favoriteType) {
        // Switch tabs if trying to show favorites of a different tab type
        if (this.query.type !== SearchFormType.Airports && favoriteType === 'airports') {
            this.query.type = SearchFormType.Airports;
            this.changeQueryParams();
            // Delay to allow for switching tabs if tab switch required
            setTimeout(function () {
                var element = document.querySelector('#favorites');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 400);
        }
        else if (this.query.type !== SearchFormType.AviationEvents && favoriteType === 'events') {
            this.query.type = SearchFormType.AviationEvents;
            this.changeQueryParams();
            // Delay to allow for switching tabs if tab switch required
            setTimeout(function () {
                var element = document.querySelector('#favorites');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 400);
        }
        else {
            var element = document.querySelector('#favorites');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };
    LandingPageComponent.prototype.clickUsorInternational = function (event) {
        if (event.value === 'International') {
            this.aviationEventFilter.international = true;
        }
        else {
            this.aviationEventFilter.international = false;
        }
        this.query.aviationEventsFilter = this.aviationEventFilter;
    };
    LandingPageComponent.prototype.onClickFuelLearnMore = function () {
        var dialogRef = this._matDialog.open(ShowDialogComponent);
    };
    return LandingPageComponent;
}());
export { LandingPageComponent };
